module.exports = __webpack_public_path__ + "static/media/ic_selected.2360aeeb.png";